import { useEffect, useState } from "react";
import Landing from "./pages/Landing";
import Success from "./pages/Success";
import WheelPage from "./pages/WheelPage";
import StorySequence from "./components/StorySequence";
import EmailForm from "./components/EmailForm";
import { registerUser } from "./utils/api";

export default function App() {
  const [screen, setScreen] = useState("landing");
  const [userEmail, setUserEmail] = useState("");
  const [prize, setPrize] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [resumeAfterReload, setResumeAfterReload] = useState(false);

  // Resume where the user left off if they reload mid-flow.
  useEffect(() => {
    const savedEmail = localStorage.getItem("userEmail");
    if (savedEmail) {
      setUserEmail(savedEmail);
      setResumeAfterReload(true);
      setScreen("wheel");
    }
  }, []);

  const handleEmailSubmit = async (email) => {
    setIsRegistering(true);
    try {
      await registerUser(email);
      localStorage.setItem("userEmail", email);
      setUserEmail(email);
      setScreen("wheel");
    } finally {
      setIsRegistering(false);
    }
  };

  const handlePrizeWon = (wonPrize) => {
    setPrize(wonPrize);
    setScreen("success");
  };

  const handleRestart = () => {
    setScreen("wheel");
  };

  switch (screen) {
    case "story":
      return <StorySequence onComplete={() => setScreen("email")} />;
    case "email":
      return <EmailForm onSubmit={handleEmailSubmit} isLoading={isRegistering} />;
    case "wheel":
      return (
        <WheelPage
          userEmail={userEmail}
          onPrizeWon={handlePrizeWon}
          showCongratulationsDirectly={resumeAfterReload}
          onBackToStory={() => setScreen("story")}
        />
      );
    case "success":
      return <Success prize={prize} onRestart={handleRestart} />;
    case "landing":
    default:
      return <Landing onContinue={() => setScreen("story")} />;
  }
}
